/* ═══════════════════════════════════════════════════════════
   OTM CBD — Panier AJAX

   Remplace le panier en mémoire de la maquette (addCart / bumpCart,
   source lignes 4527–4552) par l'API panier Shopify. La maquette
   stockait un tableau JS ; ici la source de vérité est /cart.js.

   API publique :
     otmCart.add(items, opts)   items = objet ou tableau {id, quantity, properties}
     otmCart.change(key, qty)
     otmCart.open() / .close()
     otmCart.refresh()
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Meme fabrique idempotente que dans otm-ui.js : le premier des deux
     scripts a s'executer cree le verrou, l'autre reutilise le meme
     objet. Ecrit ici aussi pour que ce fichier ne depende pas d'un
     ordre de chargement — un panneau qui ne relache pas le defilement
     est un parcours bloque, pas une degradation acceptable. */
  var scrollLock = (window.OtmScrollLock = window.OtmScrollLock || (function () {
    var ouverts = [];
    return {
      lock: function (nom) {
        if (ouverts.indexOf(nom) === -1) ouverts.push(nom);
        /* MESURÉ le 09/09/2026, 390 x 844, tiroir ouvert a 20 articles :
           le verrou ne portait que sur <body>. En posant l'overflow sur
           <body> SEUL, le document reste le proprietaire du defilement
           pour tout geste qui ne commence pas dans .otm-cart__body — soit
           TROIS zones sur cinq : l'en-tete, le total, et le bouton
           « Passer commande ». Le pied fait 211 px en bas d'ecran, la ou
           se pose le pouce.

           Sur Safari iOS, `overflow: hidden` pose sur <body> n'empeche pas
           le document de defiler au doigt ; il ne l'empeche que pose sur
           l'element racine. Le tiroir etant `position: fixed`, la page
           glissait derriere pendant que le tiroir restait immobile — ce
           que l'utilisateur decrit comme « le panier reste fige ».

           On pose donc les deux. */
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      },
      unlock: function (nom) {
        var i = ouverts.indexOf(nom);
        if (i !== -1) ouverts.splice(i, 1);
        if (ouverts.length === 0) {
          document.documentElement.style.overflow = '';
          document.body.style.overflow = '';
        }
      },
      ouverts: function () { return ouverts.slice(); }
    };
  })());

  var drawer, overlay;

  function el(id) { return document.getElementById(id); }

  function money(cents) {
    // Le format vient du réglage boutique, injecté par Liquid dans le layout.
    var fmt = (window.otmMoneyFormat || '{{amount_with_comma_separator}} €');
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function setBusy(busy) {
    if (drawer) drawer.classList.toggle('is-busy', busy);
  }

  /* Le tiroir porte aria-modal="true" : sans piege a focus, la tabulation
     en sortait et parcourait la page derriere. Et sans memoire du
     declencheur, la fermeture renvoyait le focus au debut du document.
     Les deux mesures datent du 06/09/2026. */
  var lastTrigger = null;
  var releaseTrap = null;

  function open() {
    if (!drawer) return;
    lastTrigger = document.activeElement;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    /* Verrou compte, defini dans otm-ui.js (fabrique idempotente : si ce
       fichier s'executait le premier, il le cree). Mesure du 08/09/2026 :
       le tiroir referme au-dessus d'un menu encore ouvert rendait le
       defilement a la page derriere. Instrument : la regle de
       propagation de l'overflow, pas window.scrollTo() — voir le
       commentaire du verrou dans otm-ui.js. */
    scrollLock.lock('tiroir');
    /* Même drapeau que le menu mobile : le bandeau cookies s'efface le
       temps qu'un panneau plein écran soit ouvert, et revient ensuite.
       Mesuré le 08/09/2026 — voir otm-ui.js, setOpen(). */
    document.documentElement.classList.add('otm-drawer-open');
    document.dispatchEvent(new CustomEvent('otm:drawer', { detail: { open: true } }));
    if (window.otmTrapFocus && !releaseTrap) releaseTrap = window.otmTrapFocus(drawer);
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrollLock.unlock('tiroir');
    document.documentElement.classList.remove('otm-drawer-open');
    document.dispatchEvent(new CustomEvent('otm:drawer', { detail: { open: false } }));
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
    }
    lastTrigger = null;
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) {
      n.textContent = count;
      /* Tous les [data-cart-count] ne sont pas des badges. Celui du pied
         du tiroir est declare `hidden` dans la section : c'est le PORTEUR
         de la valeur que refresh() relit, pas quelque chose a montrer.
         `n.hidden = count === 0` le devoilait des le premier article — un
         « 33 » nu sous « Voir le panier », mesure du 10/09/2026 a 390 px.
         Le defaut etait masque jusqu'ici par le pied lui-meme, qui restait
         en display:none a cause de --bare. */
      if (n.closest('[data-cart-foot]')) { n.hidden = true; return; }
      n.hidden = count === 0;
    });
  }

  /* Recharge le contenu du tiroir depuis la section rendue par Shopify.
     On passe par ?sections= pour que le HTML reste produit par Liquid,
     et non reconstruit en JS. */
  function refresh() {
    return fetch(window.Shopify.routes.root + '?sections=otm-cart-drawer', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['otm-cart-drawer'];
        if (!html) return;

        /* innerHTML detruit le bouton focalise : au clavier, chaque « + »
           renvoyait le focus au debut du document et la quantite devenait
           impossible a regler sans souris. On releve la cible avant, on la
           retrouve apres. Mesure le 06/09/2026. */
        var act = document.activeElement;
        var keep = null;
        if (act && drawer && drawer.contains(act)) {
          var d = act.dataset || {};
          var key = d.cartPlus || d.cartMinus || d.cartRemove;
          if (key) {
            var role = d.cartPlus ? 'cart-plus' : (d.cartMinus ? 'cart-minus' : 'cart-remove');
            keep = '[data-' + role + '="' + key + '"]';
          } else if (act.hasAttribute('data-cart-close')) {
            keep = '[data-cart-close]';
          }
        }

        /* On recopie AUSSI la classe, pas seulement le contenu.
           Le pied porte `otm-cart__foot--bare` quand le panier est vide,
           et cette classe vaut `display: none` (section, ligne 282). Elle
           etait posee au chargement de la page et n'etait JAMAIS retiree :
           sur une page ouverte panier vide, ajouter un article remplissait
           bien le pied — sous-total, « Passer commande », « Voir le
           panier » — mais il restait masque. Le client voyait ses articles
           et AUCUN moyen de payer, sauf a recharger la page.
           Mesure du 10/09/2026 sur otmcbd.fr, 390 px : pied present dans le
           DOM avec « Sous-total 107,94 € », rect 0 x 0, display none. */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        var target = drawer && drawer.querySelector('[data-cart-body]');
        if (fresh && target) {
          target.className = fresh.className;
          target.innerHTML = fresh.innerHTML;
        }

        var freshFoot = doc.querySelector('[data-cart-foot]');
        var targetFoot = drawer && drawer.querySelector('[data-cart-foot]');
        if (freshFoot && targetFoot) {
          targetFoot.className = freshFoot.className;
          targetFoot.innerHTML = freshFoot.innerHTML;
        }

        var c = doc.querySelector('[data-cart-count]');
        if (c) updateCount(parseInt(c.textContent, 10) || 0);

        if (keep) {
          var again = drawer.querySelector(keep);
          if (again) { try { again.focus({ preventScroll: true }); } catch (e) { again.focus(); } }
          else {
            var close = drawer.querySelector('[data-cart-close]');
            if (close) close.focus();
          }
        }
      })
      .catch(function () { /* le tiroir garde son état précédent */ });
  }

  function readError(res) {
    return res.json().then(
      function (d) { return d.description || d.message || 'Ajout impossible'; },
      function () { return 'Ajout impossible'; }
    );
  }

  /* Instantané des quantités du panier, indexé par line item key. */
  function snapshot() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var map = {};
        (c.items || []).forEach(function (i) { map[i.key] = i.quantity; });
        return map;
      })
      .catch(function () { return null; });
  }

  /* Remet le panier dans l'état décrit par un instantané.
     Les lignes apparues depuis sont ramenées à 0, donc supprimées ;
     celles qui existaient déjà retrouvent leur quantité exacte. */
  function restore(before) {
    if (!before) return Promise.resolve(false);
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var updates = {};
        var changed = false;
        (c.items || []).forEach(function (i) {
          var want = Object.prototype.hasOwnProperty.call(before, i.key) ? before[i.key] : 0;
          if (want !== i.quantity) { updates[i.key] = want; changed = true; }
        });
        if (!changed) return false;
        return fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true; });
      })
      .catch(function () { return false; });
  }

  /* items : { id, quantity, properties } ou tableau de ces objets

     AJOUT ATOMIQUE — tout ou rien.

     Diagnostiqué en runtime le 19/08/2026 : sur UN SEUL appel multi-lignes,
     quand une ligne dépasse le stock, Shopify ajoute quand même TOUTES les
     lignes en écrêtant celle en rupture, puis répond 422. Un lot de
     1 + 9999 + 1 a laissé 52 unités et 1 039,48 € au panier pendant que le
     client voyait une erreur.

     Ce n'est donc pas un problème d'appels multiples — il n'y en a qu'un —
     et il n'y a rien à « nettoyer derrière » : il faut ANNULER.

     Choix : tout ou rien, plutôt que garder l'écrêtage.
     Un pack est une unité commerciale. Six cartouches demandées, cinq
     ajoutées, et le palier affiché (4 à 6 → 17,99 €) ne correspond plus à
     ce qui sera facturé. Un panier partiel après une erreur affichée est un
     écran qui ment ; mieux vaut ne rien ajouter et le dire.

     La restauration part d'un instantané pris AVANT l'appel et ne touche
     qu'aux lignes réellement modifiées : le reste du panier est préservé. */
  function add(items, opts) {
    opts = opts || {};
    var list = Array.isArray(items) ? items : [items];
    setBusy(true);

    return snapshot().then(function (before) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list })
      })
        .then(function (res) {
          if (!res.ok) return readError(res).then(function (m) { throw new Error(m); });
          return res.json();
        })
        .then(function (data) {
          return refresh().then(function () {
            if (opts.openDrawer !== false) open();
            if (window.otmFlash && opts.message) window.otmFlash(opts.message);
            document.dispatchEvent(new CustomEvent('otm:cart:added', { detail: data }));
            return data;
          });
        })
        .catch(function (err) {
          return restore(before)
            .then(function (rolledBack) {
              return refresh().catch(function () {}).then(function () { return rolledBack; });
            })
            .then(function (rolledBack) {
              var msg = err.message;
              if (rolledBack && opts.rollbackMessage) msg = opts.rollbackMessage;
              if (window.otmFlash) window.otmFlash(msg);
              document.dispatchEvent(new CustomEvent('otm:cart:failed', {
                detail: { error: err.message, rolledBack: rolledBack }
              }));
              throw err;
            });
        });
    })
      .finally(function () { setBusy(false); });
  }

  function change(key, quantity) {
    setBusy(true);
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) return readError(res).then(function (m) { throw new Error(m); });
        return res.json();
      })
      .then(function (data) {
        return refresh().then(function () {
          document.dispatchEvent(new CustomEvent('otm:cart:changed', { detail: data }));
          return data;
        });
      })
      .catch(function (err) {
        /* Même motif que add() : change.js écrête la quantité au stock
           disponible et répond 422 alors que la ligne a changé. */
        return refresh()
          .catch(function () { /* le panier reste tel quel */ })
          .then(function () {
            if (window.otmFlash) window.otmFlash(err.message);
          });
      })
      .finally(function () { setBusy(false); });
  }

  /* ── Délégation d'évènements ─────────────────────── */
  /* Formulaires POST natifs vers /cart/add — réassort pro, « Commander à
     nouveau ». Ils sont multi-lignes et contournaient entièrement ce
     fichier : sur une rupture, Shopify écrêtait la ligne concernée, gardait
     les autres, et le navigateur atterrissait sur un panier faux sans
     qu'aucune annulation ne soit possible.

     On les route vers add(), qui est atomique. Le formulaire reste un
     vrai formulaire : sans JavaScript, le POST natif part comme avant —
     dégradé, mais fonctionnel. */
  function bindNativeForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-cart-form]');
      if (!form) return;
      var items = [];
      var byIndex = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        var m = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(el.name || '');
        if (!m) return;
        byIndex[m[1]] = byIndex[m[1]] || {};
        byIndex[m[1]][m[2]] = el.value;
      });
      Object.keys(byIndex).forEach(function (k) {
        var id = parseInt(byIndex[k].id, 10);
        var q = parseInt(byIndex[k].quantity, 10);
        if (id && q > 0) items.push({ id: id, quantity: q });
      });
      if (!items.length) return; /* rien à ajouter : on laisse le POST natif */
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      add(items, {
        message: form.dataset.cartMessage || '',
        rollbackMessage: form.dataset.cartRollback || ''
      })
        .catch(function () { /* message déjà affiché par add() */ })
        .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    });
  }

  function bind() {
    drawer = el('OtmCartDrawer');
    overlay = el('OtmCartOverlay');
    bindNativeForms();

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      if (overlay && e.target === overlay) { close(); return; }

      var minus = e.target.closest('[data-cart-minus]');
      if (minus) {
        change(minus.dataset.cartMinus, parseInt(minus.dataset.qty, 10) - 1);
        return;
      }
      var plus = e.target.closest('[data-cart-plus]');
      if (plus) {
        change(plus.dataset.cartPlus, parseInt(plus.dataset.qty, 10) + 1);
        return;
      }
      var rm = e.target.closest('[data-cart-remove]');
      if (rm) { change(rm.dataset.cartRemove, 0); return; }

      // Bouton « ajouter » simple : data-add-variant sur n'importe quel bouton
      var addBtn = e.target.closest('[data-add-variant]');
      if (addBtn) {
        e.preventDefault();
        add(
          { id: parseInt(addBtn.dataset.addVariant, 10), quantity: 1 },
          { message: addBtn.dataset.addMessage || '' }
        );
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  /* Retour depuis le paiement : la page revient du cache arrière-avant, avec
     le compteur et le tiroir figés dans leur état d'avant la commande. Le
     configurateur, lui, garde son état JS et son bouton actif — prêt à
     commander une seconde fois. Zéro occurrence de `pageshow` dans le dépôt
     avant ce jour. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh().catch(function () { /* le tiroir garde son état */ });
  });

  window.otmCart = {
    add: add, change: change, open: open, close: close, refresh: refresh, money: money
  };
})();
